import {Text} from "./Text";
import {twMerge} from "tailwind-merge";

export const BoldText = ({children, className}) => {
  return (
      <Text className={twMerge('font-bold', className)}>{children}</Text>
  )
}
